import(/* webpackMode: "eager" */ "/home/jenkins/agent/workspace/mepha/mepha-events/src/app/[locale]/error.tsx");
